import { frontendURL } from '../../../helper/URLHelper';

const ChangelogView = () => import('./ChangelogView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/changelog'),
    name: 'changelog_index',
    component: ChangelogView,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
